var FIGURE = FIGURE || {};

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();

// Video facade — used by the About page.
//
// The markup ships a poster image inside a plain link to YouTube, so with no
// JavaScript the link simply works and the visitor watches the film on YouTube.
// Here we intercept it and swap the iframe in place instead.
//
// The point is what does NOT happen on load: no third-party iframe, so none of
// YouTube's script and none of its cookies until someone actually asks to
// watch. youtube-nocookie.com and a preconnect on first intent keep it that way
// for as long as possible.
FIGURE.videoFacade = function() {
	var facades = document.querySelectorAll('.video-facade[data-youtube-id]');
	if (!facades.length) {
		return;
	}

	function preconnect(href) {
		if (document.querySelector('link[rel="preconnect"][href="' + href + '"]')) {
			return;
		}
		var link = document.createElement('link');
		link.rel = 'preconnect';
		link.href = href;
		document.head.appendChild(link);
	}

	Array.prototype.forEach.call(facades, function(facade) {
		var trigger = facade.querySelector('.video-facade-trigger');
		var id = facade.getAttribute('data-youtube-id');
		if (!trigger || !id) {
			return;
		}

		// Warm the connection when someone looks like they are about to press
		// play, so the click itself is not also paying for DNS and TLS. `once`
		// because one warm-up is all it buys us.
		['pointerenter', 'focusin'].forEach(function(event) {
			facade.addEventListener(event, function() {
				preconnect('https://www.youtube-nocookie.com');
				preconnect('https://i.ytimg.com');
			}, { once: true });
		});

		trigger.addEventListener('click', function(event) {
			// Let modified clicks through — cmd/ctrl-click to open YouTube in a
			// new tab is a reasonable thing to want, and swallowing it would be
			// worse than not having the facade at all.
			if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) {
				return;
			}
			event.preventDefault();

			var iframe = document.createElement('iframe');
			iframe.className = 'video-facade-frame';
			iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
				'?autoplay=1&rel=0';
			iframe.title = trigger.textContent.trim() || 'Video';
			iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
			iframe.allowFullscreen = true;

			facade.replaceChild(iframe, trigger);
			// The iframe is what the visitor just asked for, so move focus to it
			// rather than leaving it on a button that no longer exists.
			iframe.focus();
		});
	});
}();
